<div class="row mb-3">
    <label
        for="startupStatus"
        class="col-lg-6 col-12 col-form-label text-start"
        [translate]="'CONFIRMATION_INSTALL_PW_STARTUP_STATUS'"
    ></label>
    <div class="col-lg-5 col-12">
        <pace-core-dropdown
            id="startupStatus"
            [(model)]="model.startupStatus"
            [parentForm]="installationPaperworkFormChildren"
            (valueChange)="updateStartupStatus($event)"
        ></pace-core-dropdown>
    </div>
</div>

@if (showPunchLists()) {
    <div class="row mb-2">
        <label
            for="siemensPunchList"
            class="col-6 col-form-label text-start"
            [translate]="'CONFIRMATION_INSTALL_PW_SIEMENS_PUNCHLIST'"
        ></label>
        <div class="col-auto">
            <button
                type="button"
                class="btn btn-primary"
                (click)="addSiemensPunchcard()"
                [translate]="'CONFIRMATION_INSTALLATION_PW_ADD_PUNCHCARD'"
                [disabled]="isSiemensPunchListAddDisabled() || model.isSTPLComplete"
            ></button>
        </div>
    </div>
    @if (model.siemensPunchlist.value.length === 0) {
        <div class="row mb-2">
            <div
                class="offset-6 col col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALLATION_PW_PUNCHLIST_COMPLETE'"
            ></div>
        </div>
    }
    @for (siemensPunchItem of model.siemensPunchlist.value; track siemensPunchItem) {
        <div class="row mb-2">
            <div class="col-1 col-form-label text-end">{{ $index + 1 }}</div>
            <div class="col-9">
                <pace-core-text-input
                    [(model)]="siemensPunchItem"
                    (valueChange)="updatePunchlistStatus()"
                ></pace-core-text-input>
            </div>
            <div class="col-2">
                <button
                    type="button"
                    class="btn btn-warning"
                    (click)="removeSiemensPunchcard($index)"
                    [attr.aria-label]="'CONFIRMATION_INSTALLATION_PW_REMOVE_SIEMENS_PUNCHCARD' | translate"
                >
                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                </button>
            </div>
        </div>
    }
    <div class="row mb-2">
        <label
            for="siemensPunchList"
            class="col-6 col-form-label text-start"
            [translate]="'CONFIRMATION_INSTALL_PW_CUSTOMER_PUNCHLIST'"
        ></label>
        <div class="col-auto">
            <button
                type="button"
                class="btn btn-primary"
                (click)="addCustomerPunchcard()"
                [translate]="'CONFIRMATION_INSTALLATION_PW_ADD_PUNCHCARD'"
                [disabled]="isCustomerPunchListAddDisabled() || model.isSTPCComplete"
            ></button>
        </div>
    </div>
    @if (model.customerPunchlist.value.length === 0) {
        <div class="row mb-2">
            <div
                class="offset-6 col col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALLATION_PW_PUNCHLIST_COMPLETE'"
            ></div>
        </div>
    }
    @for (customerPunchItem of model.customerPunchlist.value; track customerPunchItem) {
        <div class="row mb-2">
            <div class="col-1 col-form-label text-end">{{ $index + 1 }}</div>
            <div class="col-9">
                <pace-core-text-input
                    [(model)]="customerPunchItem"
                    (valueChange)="updatePunchlistStatus()"
                ></pace-core-text-input>
            </div>
            <div class="col-2">
                <button
                    type="button"
                    class="btn btn-warning"
                    (click)="removeCustomerPunchcard($index)"
                    [attr.aria-label]="'CONFIRMATION_INSTALLATION_PW_REMOVE_SIEMENS_PUNCHCARD' | translate"
                >
                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                </button>
            </div>
        </div>
    }
}

<div class="row mb-3">
    <label
        for="leadPersonResponsible"
        class="col-lg-6 col-12 col-form-label text-start"
        [translate]="'CONFIRMATION_INSTALL_PW_PERSON_IS_LEAD_RESPONSIBLE'"
    ></label>
    <div class="col-lg-auto col-12">
        <pace-core-radio-input
            id="leadPersonResponsible"
            [(model)]="model.isPersonLeadResponsible"
            [parentForm]="installationPaperworkFormChildren"
            (valueChange)="updateLeadResponsibleRole()"
        ></pace-core-radio-input>
    </div>
</div>

@if (isLeadResponsibleSelectionTrue()) {
    <hr class="separator" />

    @if (
        model.installationPaperworkQuestions[model.installationPaperworkCodes.isSystemReadyForStartupAndDayOne]
            ?.Required
    ) {
        <div class="row mb-3">
            <label
                for="isSystemReadyForStartupAndDayOne"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_SYSTEM_READY_FOR_STARTUP'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isSystemReadyForStartupAndDayOne"
                    [(model)]="model.isSystemReadyForStartupAndDayOne"
                    [parentForm]="installationPaperworkFormChildren"
                    (valueChange)="updateFirstDayDependencies($event)"
                ></pace-core-radio-input>
            </div>
        </div>
        @if (isFirstDay()) {
            <div class="row mb-3">
                <label
                    for="dayOneAttachments"
                    class="col-lg-6 col-12 col-form-label text-start"
                    [translate]="'CONFIRMATION_INSTALL_PW_DAY_ONE_ATTACHMENTS'"
                ></label>
                <div class="col-lg-auto col-12 mb-3">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [ngClass]="firstDayValid() ? 'btn-primary' : 'btn-danger'"
                        [disabled]="firstDayFileUploads().length >= 12"
                        [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                        (click)="uploadFile('DAY_ONE')"
                    ></button>
                </div>
                @if (!firstDayValid()) {
                    <div
                        class="offset-lg-6 col-lg-6 col-12 text-danger"
                        id="dayOneAttachments"
                        [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE_MESSAGE'"
                    ></div>
                }
                @for (dayOneAttachment of firstDayFileUploads(); track dayOneAttachment) {
                    <div class="offset-lg-6 col-lg-6 col-12" id="dayOneAttachments">
                        File {{ $index + 1 }}: {{ dayOneAttachment }}
                    </div>
                }
            </div>
        }
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.heliumLevelArrival]?.Required) {
        <div class="row mb-3">
            <div class="col-lg-6 col-12">
                <label
                    for="heliumLevelArrival"
                    class="col-form-label text-start"
                    [translate]="'CONFIRMATION_INSTALL_PW_HELIUM_LEVEL_ARRIVAL'"
                ></label>
                <a
                    href="{{ heliumTrackerLink }}"
                    class="pace-link btn btn-link"
                    target="_blank"
                    [translate]="'INSTALLATION_PAPERWORK_HELIUM_TRACKER_LINK'"
                ></a>
            </div>
            <div class="col-lg-auto col-12">
                <pace-core-text-input
                    id="heliumLevelArrival"
                    [(model)]="model.heliumLevelArrival"
                    [parentForm]="installationPaperworkFormChildren"
                    [ariaLabel]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_SOLD_SERIAL_NR' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.heliumLevelCompletion]?.Required) {
        <div class="row mb-3">
            <div class="col-lg-6 col-12">
                <label
                    for="heliumLevelCompletion"
                    class="col-form-label text-start"
                    [translate]="'CONFIRMATION_INSTALL_PW_HELIUM_LEVEL_COMPLETION'"
                ></label>

                <a
                    href="{{ heliumTrackerLink }}"
                    class="pace-link btn btn-link"
                    target="_blank"
                    [translate]="'INSTALLATION_PAPERWORK_HELIUM_TRACKER_LINK'"
                ></a>
            </div>
            <div class="col-lg-auto col-12">
                <pace-core-text-input
                    id="heliumLevelCompletion"
                    [(model)]="model.heliumLevelCompletion"
                    [parentForm]="installationPaperworkFormChildren"
                    [ariaLabel]="'CONFIRMATION_INSTALL_PW_HELIUM_LEVEL_COMPLETION' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isHeliumTrackerDataEntered]?.Required) {
        <div class="row mb-3">
            <label
                for="isHeliumTrackerDataEntered"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_HELIUM_TRACKER_DATA'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isHeliumTrackerDataEntered"
                    [(model)]="model.isHeliumTrackerDataEntered"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isIVKVerified]?.Required) {
        <div class="row mb-3">
            <label for="isIVKVerified" class="col-lg-6 col-12 col-form-label text-start"
                >{{ 'CONFIRMATION_INSTALL_PW_IVK_VERIFIED' | translate }}
                <button type="button" class="btn btn-link" (click)="openEquipmentConfig()">
                    <span [translate]="'NOTIFICATION_DETAILS_DETAIL_LINKS_MAINTENANCE_SYSTEM_CONFIG'"></span>
                </button>
            </label>
            <div class="col-lg-auto col-12">
                <pace-core-checkbox-input
                    id="isIVKVerified"
                    [(model)]="model.isIVKVerified"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-checkbox-input>
            </div>
        </div>
    }
    @if (
        model.installationPaperworkQuestions[model.installationPaperworkCodes.differentSerialNumberThanIVKLongText]
            ?.Required
    ) {
        <div class="row mb-3">
            <label
                for="numberDifferentThanIVK"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_ITEM_DIFFERNT_THAN_IVK'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="numberDifferentThanIVK"
                    [(model)]="model.isSerialNumberDifferentThanIVK"
                    [parentForm]="installationPaperworkFormChildren"
                    (valueChange)="setSerialNumberDifferentThanIVK()"
                ></pace-core-radio-input>
            </div>
            @if (isSerialNumberDifferentFromIVKSelected() === 0) {
                <div class="offset-lg-6 col-lg-5 col-12 mt-3">
                    <pace-core-text-input
                        [(model)]="model.differentSerialNumberThanIVKLongText"
                        [parentForm]="installationPaperworkFormChildren"
                        [ariaLabel]="'CONFIRMATION_INSTALL_PW_ITEM_DIFFERNT_THAN_IVK' | translate"
                    ></pace-core-text-input>
                </div>
            }
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isSRSVerifiedBySrsTse]?.Required) {
        <div class="row mb-3">
            <label
                for="isSRSVerified"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_SRS_VERIFIED'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isSRSVerified"
                    [(model)]="model.isSRSVerifiedBySrsTse"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isDICOMProvided]?.Required) {
        <div class="row mb-3">
            <label
                for="isDicomProvided"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_DICOM_NODES_PROVIDED'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isDicomProvided"
                    [(model)]="model.isDICOMProvided"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isSafetyUICompleted]?.Required) {
        <div class="row mb-3">
            <label
                for="isSafetyUIComplete"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_SAFETY_UI_COMPLETED'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isSafetyUIComplete"
                    [(model)]="model.isSafetyUICompleted"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.finalDayAttachments]?.Required) {
        <div class="row mb-3">
            <label
                for="finalDayAttachments"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_FINAL_DAY_ATTACHMENTS'"
            ></label>
            <div class="col-auto mb-3">
                <button
                    type="button"
                    class="btn btn-primary"
                    [ngClass]="finalDayValid() ? 'btn-primary' : 'btn-danger'"
                    [disabled]="finalDayFileUploads().length >= 12"
                    [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                    [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                    (click)="uploadFile('FINAL_DAY')"
                ></button>
            </div>
            @if (!finalDayValid()) {
                <div class="col-auto me-auto pt-1">
                    <fa-icon [icon]="faTimesCircle" size="lg" class="invalid-icon"></fa-icon>
                </div>
                <div
                    class="offset-lg-6 col-lg-6 col-12 text-danger"
                    [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE_MESSAGE'"
                ></div>
            } @else if (model.finalDayAttachments.options.completed()) {
                <div class="col-auto me-auto pt-1">
                    <fa-icon [icon]="faCheckCircle" size="lg" class="valid-icon"></fa-icon>
                </div>
            }

            @for (finalDayAttachment of finalDayFileUploads(); track finalDayAttachment) {
                <div class="offset-lg-6 col-lg-6 col-12">File {{ $index + 1 }}: {{ finalDayAttachment }}</div>
            }
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.cseHandoverMethod]?.Required) {
        <div class="row mb-3">
            <label
                for="cseHandoverMethod"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_CSE_HANDOVER_METHOD'"
            ></label>
            <div class="col-lg-5 col-12">
                <pace-core-dropdown
                    id="cseHandoverMethod"
                    [(model)]="model.cseHandoverMethod"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-dropdown>
            </div>
        </div>
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.cseHandoverName]?.Required) {
        <div class="row mb-3">
            <label
                for="cseHandoverName"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_CSE_HANDOVER_NAME'"
            ></label>
            <div class="col-lg-3 col-12">
                <pace-core-dropdown
                    id="cseHandoverName"
                    [(model)]="model.cseHandoverName"
                    [parentForm]="installationPaperworkFormChildren"
                    [ariaLabel]="'CONFIRMATION_INSTALL_PW_CSE_HANDOVER_NAME' | translate"
                ></pace-core-dropdown>
            </div>
            <div class="col-lg-3 col-12 col-form-label text-center" paceCoreLink>
                <a
                    href="{{ siemensCloudDirectoryLink }}"
                    class="pace-link btn btn-link"
                    target="_blank"
                    [translate]="'INSTALLATION_PAPERWORK_SCD_SIEMENS_CLOUD_LINK'"
                ></a>
            </div>
        </div>
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.cseHandoverDate]?.Required) {
        <div class="row mb-3">
            <label
                for="cseHandoverDate"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_CSE_HANDOVER_DATE'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-date-input
                    id="cseHandoverDate"
                    [(model)]="model.cseHandoverDate"
                    [parentForm]="installationPaperworkFormChildren"
                    [ariaLabel]="'CONFIRMATION_INSTALL_PW_CSE_HANDOVER_DATE' | translate"
                ></pace-core-date-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isArtisLicenseKeyRemoved]?.Required) {
        <div class="row mb-3">
            <label
                for="isArtisLicenseKeyRemoved"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_ARTIS_LICENSE_KEY'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isArtisLicenseKeyRemoved"
                    [(model)]="model.isArtisLicenseKeyRemoved"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isIVKsubmittedForSyngo]?.Required) {
        <div class="row mb-3">
            <label
                for="isIVKsubmittedForSyngo"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_IVK_SUBMITTED'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isIVKsubmittedForSyngo"
                    [(model)]="model.isIVKsubmittedForSyngo"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }
    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isLeonardoLicenseKeyRemoved]?.Required) {
        <div class="row mb-3">
            <label
                for="isLeonardoLicenseKeyRemoved"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_LONARDO_LICENSE_KEY'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isLeonardoLicenseKeyRemoved"
                    [(model)]="model.isLeonardoLicenseKeyRemoved"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isSiemensSoldOEMEquipment]?.Required) {
        <div class="row mb-3">
            <label
                for="isSoldOEM"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_SOLD'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isSoldOEM"
                    [(model)]="model.isSiemensSoldOEMEquipment"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
            @if (model.isSiemensSoldOEMEquipment.getSelectedIndex() === 0) {
                @if (model.soldOEMEquipmentList.length === 0) {
                    <div
                        class="offset-lg-6 col-lg-6 col-12 text-danger mt-3"
                        [translate]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_REQUIRED'"
                    ></div>
                }
                @for (oemEquipment of model.soldOEMEquipmentList; track oemEquipment) {
                    <div class="offset-lg-6 col-lg-4 col-10 mt-3">
                        {{ oemEquipment }}
                    </div>
                    <div class="col mt-3">
                        <button
                            type="button"
                            class="btn btn-warning"
                            [attr.aria-label]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_SOLD_DELETE' | translate"
                            (click)="deleteSoldEquipment($index)"
                        >
                            <fa-icon [icon]="faTrashAlt"></fa-icon>
                        </button>
                    </div>
                }
                <div class="offset-lg-6 col-lg-4 col-10 mt-3">
                    <pace-core-text-input
                        [(model)]="newSoldEquipmentModel.oemType"
                        [parentForm]="oemComponentForm"
                        [ariaLabel]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_SOLD_TYPE' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="offset-lg-6 col-lg-4 col-10 mt-3">
                    <pace-core-text-input
                        [(model)]="newSoldEquipmentModel.oemModelNr"
                        [parentForm]="oemComponentForm"
                        [ariaLabel]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_SOLD_MODEL' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="offset-lg-6 col-lg-4 col-10 mt-3">
                    <pace-core-text-input
                        [(model)]="newSoldEquipmentModel.oemSerialNr"
                        [parentForm]="oemComponentForm"
                        [ariaLabel]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_SOLD_SERIAL_NR' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col mt-3">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_OEM_EQUIPMENT_SOLD_ADD' | translate"
                        [disabled]="(oemComponentForm?.statusChanges | async) === 'INVALID'"
                        (click)="addSoldEquipment()"
                    >
                        Add
                    </button>
                </div>
            }
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isPaceStartupAttached]?.Required) {
        <div class="row mb-3">
            <label
                for="paceStartup"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_PACE_STARTUP_ATTACHED'"
            ></label>
            <div class="col-lg-6 col-12 row">
                <div class="col-auto mb-3 text-start">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [ngClass]="isPaceStartupAttachedValid() ? 'btn-primary' : 'btn-danger'"
                        [translate]="'CONFIRMATION_INSTALL_PW_CHECK_FORMS'"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_CHECK_FORMS' | translate"
                        (click)="checkPaceForms()"
                    ></button>
                </div>
                <div class="col-auto mb-3 text-start">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [ngClass]="isPaceStartupAttachedValid() ? 'btn-primary' : 'btn-danger'"
                        [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                        (click)="uploadFile('IN15_SUR')"
                    ></button>
                </div>
                <div class="col-10">
                    <pace-core-text-input
                        id="paceStartup"
                        [(model)]="model.isPaceStartupAttached"
                        [parentForm]="installationPaperworkFormChildren"
                    ></pace-core-text-input>
                </div>
                <div class="col-2 text-center align-content-center">{{ model.startupFormSubmitStatus() }}</div>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.attachIQAPReport]?.Required) {
        <div class="row mb-3">
            <label
                for="attachIQAPReport"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_IQAP_REPORT_ATTACHED'"
            ></label>
            <div class="col-lg-6 col-12 row">
                <div class="col-12 mb-3 text-start">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [ngClass]="iqapReportValid() ? 'btn-primary' : 'btn-danger'"
                        [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                        (click)="uploadFile('IN16_IQAP')"
                    ></button>
                </div>
                <div class="col-10">
                    <pace-core-text-input
                        id="attachIQAPReport"
                        [(model)]="model.attachIQAPReport"
                        [parentForm]="installationPaperworkFormChildren"
                    ></pace-core-text-input>
                </div>
                <div class="col-2 text-center align-content-center">{{ model.iqapReportSubmitStatus() }}</div>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.attachFDA2579Form]?.Required) {
        <div class="row mb-3">
            <label
                for="completeFDAForm"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_FDA_FORM_COMPLETED'"
            ></label>
            <div class="col-lg-auto col-12">
                <button
                    type="button"
                    class="btn btn-primary"
                    [ngClass]="isFdaFormValid() || !isFdaFormRequired() ? 'btn-primary' : 'btn-danger'"
                    [translate]="'INSTALLATION_PAPERWORK_FDA_FORM'"
                    [attr.aria-label]="'INSTALLATION_PAPERWORK_FDA_FORM' | translate"
                    [disabled]="model.isFDA2579FormCompletedOnPreviousTask"
                    (click)="openFDA2579()"
                ></button>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isIseCseMetricFormComplete]?.Required) {
        <div class="row mb-3">
            <label for="formIseCse" class="col-lg-6 col-12 col-form-label text-start">
                <span class="pe-3">
                    {{ 'CONFIRMATION_INSTALL_PW_ISE_CSE_METRIC_FORM' | translate }}
                </span>
                <a href="{{ iseCseMetricFormAppLink }}" class="pace-link btn btn-link ps-0" target="_blank">
                    <span [translate]="'CONFIRMATION_INSTALL_PW_ISE_CSE_METRIC_FORM_LINK'"></span>
                </a>
            </label>
            <div class="col-lg-auto col-12">
                <pace-core-checkbox-input
                    id="formIseCse"
                    [(model)]="model.isIseCseMetricFormCompleted"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-checkbox-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isChillerFlModelSerialGiven]?.Required) {
        <div class="row mb-3">
            <label
                for="isChillerGiven"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_CHILLER_FL_MODEL_SERIAL_OPTION'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isChillerGiven"
                    [(model)]="model.isChillerFlModelSerialGiven"
                    [parentForm]="installationPaperworkFormChildren"
                    (valueChange)="updateIsChillerInfoNeeded($event)"
                ></pace-core-radio-input>
            </div>
        </div>
        @if (isChillerInfoNeeded()) {
            <div class="row mb-3">
                @if (model.chillerFunctionalLocation) {
                    <label
                        for="chillerFL"
                        class="offset-lg-1 col-lg-5 col-12 col-form-label text-start"
                        [translate]="'CONFIRMATION_INSTALL_PW_CHILLER_FL'"
                    ></label>
                    <div class="col-lg-auto col-12">
                        <pace-core-text-input
                            id="chillerFL"
                            [(model)]="model.chillerFunctionalLocation"
                            [parentForm]="installationPaperworkFormChildren"
                            [ariaLabel]="'CONFIRMATION_INSTALL_PW_CHILLER_FL' | translate"
                        ></pace-core-text-input>
                    </div>
                }
            </div>
            <div class="row mb-3">
                @if (model.chillerMakeModelNumber) {
                    <label
                        for="chillerModel"
                        class="offset-lg-1 col-lg-5 col-12 col-form-label text-start"
                        [translate]="'CONFIRMATION_INSTALL_PW_CHILLER_MODEL'"
                    ></label>
                    <div class="col-lg-auto col-12">
                        <pace-core-text-input
                            id="chillerModel"
                            [(model)]="model.chillerMakeModelNumber"
                            [parentForm]="installationPaperworkFormChildren"
                            [ariaLabel]="'CONFIRMATION_INSTALL_PW_CHILLER_MODEL' | translate"
                        ></pace-core-text-input>
                    </div>
                }
            </div>
            <div class="row mb-3">
                @if (model.chillerSerialNumber) {
                    <label
                        for="chillerSerial"
                        class="offset-lg-1 col-lg-5 col-12 col-form-label text-start"
                        [translate]="'CONFIRMATION_INSTALL_PW_CHILLER_SERIAL'"
                    ></label>
                    <div class="col-lg-auto col-12">
                        <pace-core-text-input
                            id="chillerSerial"
                            [(model)]="model.chillerSerialNumber"
                            [parentForm]="installationPaperworkFormChildren"
                            [ariaLabel]="'CONFIRMATION_INSTALL_PW_CHILLER_SERIAL' | translate"
                        ></pace-core-text-input>
                    </div>
                }
            </div>
        }
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.magneticCurrent]?.Required) {
        <div class="row mb-3">
            <label
                for="magneticCurrent"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_FINAL_MAGNET_CURRENT'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-text-input
                    id="magneticCurrent"
                    [(model)]="model.magneticCurrent"
                    [parentForm]="installationPaperworkFormChildren"
                    [ariaLabel]="'CONFIRMATION_INSTALL_PW_FINAL_MAGNET_CURRENT' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isMagnetRampedDownAtRequest]?.Required) {
        <div class="row mb-3">
            <label
                for="isMagnetRampedDownAtRequest"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_MAGNET_RAMPED_DOWN_AT_REQUEST'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="isMagnetRampedDownAtRequest"
                    [(model)]="model.isMagnetRampedDownAtRequest"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }

    @if (
        model.installationPaperworkQuestions[model.installationPaperworkCodes.syngoClassicOrNativeSoftware]?.Required
    ) {
        <div class="row mb-3">
            <label
                for="syngoClassiOrNative"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_SYGNO_CLASSIC_OR_NATIVE'"
            ></label>
            <div class="col-lg-5 col-12">
                <pace-core-dropdown
                    id="syngoClassiOrNative"
                    [(model)]="model.syngoClassicOrNativeSoftware"
                    [parentForm]="installationPaperworkFormChildren"
                    (valueChange)="setIsSyngoClassic()"
                ></pace-core-dropdown>
            </div>
        </div>
        @if (isSyngoClassic()) {
            <div class="row mb-3">
                <label
                    for="syngoSafteyAttachments"
                    class="offset-lg-1 col-lg-5 col-12 col-form-label text-start"
                    [translate]="'CONFIRMATION_INSTALL_PW_SAFETY_RELATED_REPORT'"
                ></label>
                <div class="col-lg-6 col-12 row">
                    <div class="col-12 mb-3 text-start">
                        <button
                            type="button"
                            class="btn btn-primary"
                            [ngClass]="syngoSafetyRelatedReportValid() ? 'btn-primary' : 'btn-danger'"
                            [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                            [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                            (click)="uploadFile('IN26_SRT')"
                        ></button>
                    </div>
                    <div class="col-10">
                        <pace-core-text-input
                            id="syngoSafteyAttachments"
                            [(model)]="model.attachSyngoSafetyRelatedReport"
                            [parentForm]="installationPaperworkFormChildren"
                        ></pace-core-text-input>
                    </div>
                    <div class="col-2 text-center align-content-center">
                        {{ model.syngoSafetyReportSubmitStatus() }}
                    </div>
                </div>
            </div>
        }
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.preRampPhotos]?.Required) {
        <div class="row mb-3">
            <label
                for="preRampAttach"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_PRE_RAMP_PHOTOS'"
            ></label>
            <div class="col-auto mb-3">
                <button
                    type="button"
                    class="btn btn-primary"
                    [ngClass]="preRampValid() ? 'btn-primary' : 'btn-danger'"
                    [disabled]="preRampAttachments().length >= 12"
                    [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                    [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                    (click)="uploadFile('PRE_RAMP')"
                ></button>
            </div>
            @if (!preRampValid()) {
                <div class="col-auto me-auto pt-1">
                    <fa-icon [icon]="faTimesCircle" size="lg" class="invalid-icon"></fa-icon>
                </div>
                <div
                    class="offset-lg-6 col-lg-6 col-12 text-danger"
                    id="preRampAttach"
                    [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE_MESSAGE'"
                ></div>
            } @else if (model.preRampPhotos.options.completed()) {
                <div class="col-auto me-auto pt-1">
                    <fa-icon [icon]="faCheckCircle" size="lg" class="valid-icon"></fa-icon>
                </div>
            }
            @for (preRampPhoto of preRampAttachments(); track preRampPhoto) {
                <div class="offset-lg-6 col-lg-6 col-12" id="dayOneAttachments">
                    File {{ $index + 1 }}: {{ preRampPhoto }}
                </div>
            }
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.isMRDoorSwitchOperational]?.Required) {
        <div class="row mb-3">
            <label
                for="mrDoorSwitch"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_MR_DOOR_SWITCH_OPERATIONAL'"
            ></label>
            <div class="col-lg-auto col-12">
                <pace-core-radio-input
                    id="mrDoorSwitch"
                    [(model)]="model.isMRDoorSwitchOperational"
                    [parentForm]="installationPaperworkFormChildren"
                ></pace-core-radio-input>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.startupReportMR]?.Required) {
        <div class="row mb-3">
            <label
                for="startupReportMR"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_STARTUP_REPORT'"
            ></label>
            <div class="col-lg-6 col-12 row">
                <div class="col-12 mb-3 text-start">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [ngClass]="startupReportMRValid() ? 'btn-primary' : 'btn-danger'"
                        [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                        (click)="uploadFile('IN30_SUR')"
                    ></button>
                </div>
                <div class="col-10">
                    <pace-core-text-input
                        id="startupReportMR"
                        [(model)]="model.startupReportMR"
                        [parentForm]="installationPaperworkFormChildren"
                    ></pace-core-text-input>
                </div>
                <div class="col-2 text-center align-content-center">{{ model.startupReportMRSubmitStatus() }}</div>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.installationReport]?.Required) {
        <div class="row mb-3">
            <label
                for="installationReport"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_ATTACH_SIGNED_INSTALLATION_REPORT'"
            ></label>
            <div class="col-lg-6 col-12 row">
                <div class="col-auto mb-3 text-start">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [ngClass]="installationReportValid() ? 'btn-primary' : 'btn-danger'"
                        [translate]="'CONFIRMATION_INSTALL_PW_CHECK_FORMS'"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_CHECK_FORMS' | translate"
                        (click)="checkPaceForms()"
                    ></button>
                </div>
                <div class="col-auto mb-3 text-start">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [ngClass]="installationReportValid() ? 'btn-primary' : 'btn-danger'"
                        [translate]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE'"
                        [attr.aria-label]="'CONFIRMATION_INSTALL_PW_UPLOAD_FILE' | translate"
                        (click)="uploadFile('IN31_IR')"
                    ></button>
                </div>
                <div class="col-10">
                    <pace-core-text-input
                        id="installationReport"
                        [(model)]="model.installationReport"
                        [parentForm]="installationPaperworkFormChildren"
                    ></pace-core-text-input>
                </div>
                <div class="col-2 text-center align-content-center">{{ model.installationReportSubmitStatus() }}</div>
            </div>
        </div>
    }

    @if (model.installationPaperworkQuestions[model.installationPaperworkCodes.siteType]?.Required) {
        <div class="row mb-3">
            <label
                for="siteType"
                class="col-lg-6 col-12 col-form-label text-start"
                [translate]="'CONFIRMATION_INSTALL_PW_SITE_TYPE'"
            ></label>
            <div class="col-lg-5 col-12">
                <pace-core-dropdown
                    id="siteType"
                    [(model)]="model.siteType"
                    [parentForm]="installationPaperworkFormChildren"
                    (valueChange)="updateSiteType()"
                ></pace-core-dropdown>
            </div>
            @if (showSiteTypeComment()) {
                <div class="offset-lg-6 col-lg-6 col-12 mt-3">
                    <pace-core-text-input [(model)]="model.siteTypeComment"></pace-core-text-input>
                </div>
            }
        </div>
    }
}
